import React from "react";

import { SaleStatusBadge } from "components/Badge/SaleStatusBadge";

export const E_CONTRACT_STATUS_COLOR: Record<string, string> = {
  "Not Drafted": "gray78",
  "Part Drafted": "inProgress",
  Drafted: "gray9C",
  "Part Sent": "inProgress",
  Sent: "inProgress",
  "Part Accepted": "inProgress",
  Accepted: "success",
};

interface EContractStatusBadgeProps {
  value: string;
  forGrid?: boolean;
}

export function EContractStatusBadge({
  value,
  forGrid = false,
}: EContractStatusBadgeProps) {
  return (
    <SaleStatusBadge
      label={value}
      color={E_CONTRACT_STATUS_COLOR[value] ?? "gray9C"}
      forGrid={forGrid}
    />
  );
}

export function EContractStatusRenderer({
  value,
  node,
}: {
  value: string | null;
  node: { group: boolean };
}) {
  if (node?.group) {
    return value ?? null;
  }
  if (!value) return null;
  return <EContractStatusBadge value={value} forGrid />;
}
